import axios from "axios"
import qs from "qs"
import Vue from "vue"
import router from "../router"
var vm = new Vue()
const baseUrl = "http://bimshowapi.vstrain.cn/";
const rgzUrl = "http://www.rgzcloud.com"
const _this = this
axios.interceptors.response.use(res => {
	// console.log("请求地址：" + res)
	// console.log(res.data)
	// console.log(JSON.parse(res.data));
	// return (JSON.parse(res.data));
	if (res.data.hasOwnProperty('code') && res.data.code != 0  && res.data.code != 5012 && res.data.code != 8000 && res.data.code != 5018&& res.data.code != 5017) {
		vm.$message({
			message: res.data.ret,
			type: "warning",
			offset:100
		});
	};
	if(res.data.ret =="token值过期"){
        localStorage.removeItem("storage")
        localStorage.removeItem("session")
        localStorage.removeItem("token")
        // _this.$router.push({ path: "/" });
        window.location.href="/";
    }else {
        return res.data;
    }
})
// 后台上线出问题，排除是否为接口问题放到前端进行简单测试请求一下
// export const requestTest = () => {
//     return axios({
//         url: baseUrl + "/admin_activity/activity"
//     })
// }
export const token = () => {
	let token = localStorage.getItem("token");
	if (token == null) {
		location.href = '#/SignIn';
	}
	return token;
}
// export const istoken = () => {
// 	let token = localStorage.getItem("token");
// 	if (token == null) {
// 		location.href = '/';
// 	}
// 	return token;
// }
//获取首页最新数据
export const requestNavBar_10 = () => {
	var data = {};
	data.state = 10;
	return axios({
		url: baseUrl + "new_resource?data=" + JSON.stringify(data),
		method: 'GET',
	})
}
//资源下载
export const resource_download = (data) => {
    data.token=token()
    return axios({
        url: baseUrl + "resource_download?data=" + JSON.stringify(data),
		method: 'POST',
    })
}
//获取首页最优数据 模型库
export const resource_mould = (data) => {
	return axios({
		url: baseUrl + "resource_mould?data=" + JSON.stringify(data),
		method: 'GET',
	})
}
//获取首页最优数据 动画
export const resource_animation = (data) => {
	return axios({
		url: baseUrl + "resource_animation?data=" + JSON.stringify(data),
		method: 'GET',
	})
}
//获取banner
export const requestBanner = () => {
	return axios({
		url: baseUrl + "slide_list",
		method: 'GET',
	})
}
//提现
export const requestWithdrawal_add = (data) => {
	data.token= token()
    return axios({
        url: baseUrl + "withdrawal_add?data=" + JSON.stringify(data),
		method: 'POST',
    })
}
//登录
export const requestLogin = (info) => {
	return axios({
		url: baseUrl + "account_login?data=" + JSON.stringify(info),
		method: 'POST',
	})
}
//退出登录
export const requestSignout = (info) => {
	return axios({
		url: baseUrl + "account_logout?data=" + JSON.stringify(info),
		method: 'POST',
	})
}
// 获取目录
export const requestCatalog = (id) => {
	let typedata = {
		parent_id: id
	}
	return axios({
		url: baseUrl + "category_list?data=" + JSON.stringify(typedata),
		method: 'POST',
	})
}
// 获取目录
export const requestCatalog_All = () => {
    return axios({
        url: baseUrl + "get_resource_list"
    })
}
// 获取软件以及版本
export const requestMeta_getsoft = () => {
    return axios({
        url: baseUrl + "meta_getsoft"
    })
}

// 获取资源列表resource_list_sort
export const requestSort = (node_id,page) => {
    page=page==undefined?"1":page;
	node_id.paginate=node_id.paginate==undefined?30:node_id.paginate
	return axios({
		url: baseUrl + "resource_list_sort?data=" + JSON.stringify(node_id)+"&page="+page,
		method: 'GET',
	})

}
// 获取资源详情
export const requestDetails = (node_id) => {
    node_id.token=token();
    return axios({
        url: baseUrl + "resource_details?data=" + JSON.stringify(node_id),
		method: 'GET',
    })
}
// 手机号查询
export const requestaccount_exist= (node_id) => {
    return axios({
        url: baseUrl + "account_exist?data=" + JSON.stringify(node_id),
		method: 'POST',
    })
}
// 测试订单
export const requestestalipay= (node_id) => {
    return axios({
        url: baseUrl + "testalipay?data=" + JSON.stringify(node_id)
    })
}
// 调起支付宝支付)
export const requestesalipay= (node_id) => {
    node_id.token=token()
    return axios({
        url: baseUrl + "alipay?data=" + JSON.stringify(node_id),
		method: 'POST',
    })
}
// 调起微信支付)
export const requesteswxpay= (node_id) => {
    node_id.token=token()
    return axios({
        url: baseUrl + "wxpay?data=" + JSON.stringify(node_id),
		method: 'POST',
    })
}
// 测试确认
export const requestcheck_orderstatus= (node_id) => {
    return axios({
        url: baseUrl + "check_orderstatus?data=" + JSON.stringify(node_id),
		method: 'POST',
    })
}
export const requestcheck_check_orderstate= (node_id) => {
    node_id.token=token()
    return axios({
        url: baseUrl + "check_orderstate?data=" + JSON.stringify(node_id),
		method: 'POST',
    })
}

// 支付宝url
export const requestalipay= (node_id) => {
    return axios({
        url: baseUrl + "alipay?data=" + JSON.stringify(node_id)
    })
}

// 创建订单
export const requestcreate_order= (node_id) => {
    return axios({
        url: baseUrl + "create_order?data=" + JSON.stringify(node_id)
    })
}

//获取是否购买资源
export const requestResource_purchase = (info) => {
    info.token=token();
    return axios({
        url: baseUrl + "resource_purchase?data=" + JSON.stringify(info),
		method: 'POST',
    })
}
// 加入购物车 account_cart_add
export const requestAddpush = (id) => {
	let addpush = {
		token: token(),
        resource_id: id
	}
	return axios({
		method: 'POST',
		url: baseUrl + "account_cart_add?data=" + JSON.stringify(addpush)
	})
}
// 获取购物车列表 account_cart_list
export const requestAddlist = () => {
	let addpush = {
		token: token(),
	}
	return axios({
		method: 'POST',
		url: baseUrl + "account_cart_list?data=" + JSON.stringify(addpush)
	})
}
// 删除购物车列表 account_cart_delete  delete_list_all
export const requestDeletelist = (id) => {
	let addpush = {
		token: token(),
        resource_id: id,
	}
	return axios({
		method: 'POST',
		url: baseUrl + "account_cart_delete?data=" + JSON.stringify(addpush)
	})
}
// 删除购物车列表 account_cart_delete_list  delete_list_all
export const requestDeletelistall = (id) => {
	let addpush = {
		token: token(),
		value_array: id,
	}
	return axios({
		method: 'POST',
		url: baseUrl + "account_cart_delete_list?data=" + JSON.stringify(addpush)
	})
}
// 站内消息列表 requestMessage_list
export const requestMessage_list = (id) => {
	let addpush = {
		token: token(),
		type: id,
	}
	return axios({
		url: baseUrl + "account_message_list?data=" + JSON.stringify(addpush),
		method: 'POST',
	})
}
// 站内消息详情 account_message_details
export const requestMessage_details = (id) => {
	let addpush = {
		token: token(),
		id: id,
	}
	return axios({
		url: baseUrl + "account_message_details?data=" + JSON.stringify(addpush),
		method: 'POST',
	})
}
//充值记录   log_resource
export const requestPurchase = (val) => {
	if (val == undefined) {
		val = 1;
	}
	let addpush = {
		token: token(),
		page: val,
	}
	return axios({
		url: baseUrl + "log_charge?data=" + JSON.stringify(addpush),
		method: 'POST',
	})
}
//购买出售记录   log_resource   type=1 购买    =2 出售
export const requestRecords = (id, val,is_animation) => {
	if (val == undefined) {
		val = 1;
	}
	if (is_animation == undefined) {
		is_animation = null;
	}
	let addpush = {
		token: token(),
		type: id,
		is_animation:is_animation
	}

	return axios({
		url: baseUrl + "log_resource?data=" + JSON.stringify(addpush)+"&page="+val,
		method: 'POST',
	})
}
//购买空间
export const requestStorage_log = (info) => {
    if (info == undefined) {
        info = 1;
    }
    let addpush = {
        token: token(),
        page:info
    }
    return axios({
        url: baseUrl + "log_storage?data=" + JSON.stringify(addpush),
		method: 'POST',
    })
}
//搜索资源列表
export const requestSearch_resource = (info,val) => {
    if (val == undefined) {
        val = 1;
    }
    return axios({
        url: baseUrl + "newsearch_resource?data=" + JSON.stringify(info)+"&page="+val,
		method: 'GET',
    })
}

//购买会员记录
export const requestMember = (info) => {
    if (info == undefined) {
        info = 1;
    }
    let addpush = {
        token: token(),
		page:info
    }

    return axios({
        url: baseUrl + "log_member?data=" + JSON.stringify(addpush),
		method: 'POST',
    })
}
//用户/空间/金币/会员等级信息   account_storage
export const requestStorage = () => {
	let addpush = {
		token: token(),
	}
	return axios({
		method: 'POST',
		url: baseUrl + "account_storage?data=" + JSON.stringify(addpush)
	})
}
//购物车购买资源
export const requestAccount_cart = (info) => {
    let addpush = {
        token: token(),
        value_array:info
    }
    return axios({
        method: 'POST',
        url: baseUrl + "account_cart_transaction?data=" + JSON.stringify(addpush)
    })
}
//resource_crumbs 资源面包屑导航
//购物车购买资源
export const requestAccount_crumbs = (info) => {
    let addpush = {
        id: info,
    }
    return axios({
        method: 'GET',
        url: baseUrl + "resource_crumbs?data=" + JSON.stringify(addpush)
    })
}
//上传批量
export const requestShowuploadfile= (info) => {
    console.log(info)
    console.log(JSON.stringify(info))
    return axios({
        method: 'POST',
        url:  "http://www.bimmodels.cn/platform/" + "show/showuploadfile",
		data:info
    })
}

//购买内存空间
export const requestAdd_storage = (info) => {
    let addpush = {
        token: token(),
        storage:info
    }
    return axios({
        method: 'POST',
        url: baseUrl + "add_storage?data=" + JSON.stringify(addpush)
    })
}
//发送短信
export const requestSend_sms = (info) => {
    let addpush = {
        mobile:info,
    }
    return axios({
        method: 'POST',
        url: baseUrl + "send_sms?data=" + JSON.stringify(addpush)
    })
}
//验证短信
export const requestCheck_sms = (info) => {
    info.token= token();
    return axios({
        method: 'POST',
        url: baseUrl + "check_sms?data=" + JSON.stringify(info)
    })
}
//修改个人信息
export const requestAccount_info= (info) => {
    info.token= token();
    return axios({
        method: 'POST',
        url: baseUrl + "account_modify?data=" + JSON.stringify(info)
    })
}
//获取个人信息
export const requestAccount= () => {
    let addpush = {
        token: token(),
    }
    return axios({
        method: 'POST',
        url: baseUrl + "account_info?data=" + JSON.stringify(addpush)
    })
}
//修改个人信息-密码
export const requestPassword_reset= (info) => {
    info.token= token();
    return axios({
        method: 'POST',
        url: baseUrl + "account_password_reset?data=" + JSON.stringify(info)
    })
}
//购买会员
export const requestAdd_member= (info) => {
    info.token= token();
    return axios({
        method: 'POST',
        url: baseUrl + "add_member?data=" + JSON.stringify(info)
    })
}
//ip升级企业会员需要支付的费用详情
export const requestUpgrade_need_goldcoin= () => {
    let info = {
        token: token(),
    }
    return axios({
        method: 'POST',
        url: baseUrl + "upgrade_need_goldcoin?data=" + JSON.stringify(info)
    })
}
//vip升级到企业会员
export const requestUpgrade_member= () => {
    let info = {
        token: token(),
    }
    return axios({
        method: 'POST',
        url: baseUrl + "upgrade_member?data=" + JSON.stringify(info)
    })
}
//我的工程列表
export const requestdirectory_list = (addpush) => {
	addpush.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "directory_list?data=" + JSON.stringify(addpush)
	})
}

//二维码列表
export const requestaccount_code_list = (addpush,page) => {
	addpush.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_code_list?data=" + JSON.stringify(addpush)+"&page="+page
	})
}
//添加工程
export const requestdirectory_add = (addpush) => {
	addpush.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "directory_add?data=" + JSON.stringify(addpush)
	})
}
//修改工程
export const requestdirectory_modify = (addpush) => {
	addpush.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "directory_modify?data=" + JSON.stringify(addpush)
	})
}

export const requestaccount_project_list = (data,page) => {
	data.token = token()
	data.paginate=16;
	return axios({
		method: 'POST',
		url: baseUrl + "account_project_list?data=" + JSON.stringify(data)+"&page="+page
	})
}


export const requestaccount_resource_list = (data,page) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_resource_list?data=" + JSON.stringify(data)+"&page="+page
	})
}



export const requestdirectory_delete = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "directory_delete?data=" + JSON.stringify(data)
	})
}
//添加收藏
export const requestaccount_collect_add = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_collect_add?data=" + JSON.stringify(data)
	})
}
//收藏列表
export const requestaccount_account_list = (data,page) => {
	data.token = token()
	data.paginate=16;
	return axios({
		method: 'POST',
		url: baseUrl + "account_list?data=" + JSON.stringify(data)+"&page="+page
	})
}
//删除收藏
export const requestaccount_account_collect_delete = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_collect_delete?data=" + JSON.stringify(data)
	})
}
//删除多个收藏
export const requestaccount_account_collect_delete_list = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_collect_delete_list?data=" + JSON.stringify(data)
	})
}
//我的分享
export const requestaccount_account_share_list = (data,page) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_share_list?data=" + JSON.stringify(data)+"&page="+page
	})
}
//上传
export const requestaccount_resource_add = (data) => {
    data.token = token()
    return axios({
        method: 'POST',
        url: baseUrl + "account_resource_add?data=" + JSON.stringify(data)
    })
}
//修改上传
export const requestaccount_resource_update = (data) => {
    data.token = token()
    return axios({
        method: 'POST',
        url: baseUrl + "account_resource_update?data=" + JSON.stringify(data)
    })
}
//转移文件
export const account_resource_transfer = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_resource_transfer?data=" + JSON.stringify(data)
	})
}

//查看二维码是否存在
export const account_code_exists = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_code_exists?data=" + JSON.stringify(data)
	})
}
//添加二维码
export const account_code_add = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_code_add?data=" + JSON.stringify(data)
	})
}
//添加二维码扣除金币
export const code_deduction = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "code_deduction?data=" + JSON.stringify(data)
	})
}
//删除二维码
export const account_code_delete = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_code_delete?data=" + JSON.stringify(data)
	})
}
//上架资源
export const resource_state_examine = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "resource_state_examine?data=" + JSON.stringify(data)
	})
}
//下架资源
export const resource_state_lower = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "resource_state_lower?data=" + JSON.stringify(data)
	})
}
//修改定价
export const resource_goldcoin_modify = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "resource_goldcoin_modify?data=" + JSON.stringify(data)
	})
}
//同意上架
export const admin_state_upper = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "admin_state_upper?data=" + JSON.stringify(data)
	})
}
//驳回
export const admin_state_reject = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "admin_state_reject?data=" + JSON.stringify(data)
	})
}
//批量通过
export const admin_state_upper_all = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "admin_state_upper_all?data=" + JSON.stringify(data)
	})
}
//管理员下架
export const admin_state_lower = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "admin_state_lower?data=" + JSON.stringify(data)
	})
}
//管理员下架
export const resource_details = (data) => {
	data.token = token()
	return axios({
		method: 'GET',
		url: baseUrl + "resource_details?data=" + JSON.stringify(data)
	})
}
//资源删除
export const resource_delete = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "resource_delete?data=" + JSON.stringify(data)
	})
}
// 无登录获取
export const requestDetailstow = (node_id) => {
	node_id.token = ""
    return axios({
        url: baseUrl + "resource_details?data=" + JSON.stringify(node_id)
    })
}
// 最新出售作品
export const resource_sold = (data) => {
    return axios({
        url: baseUrl + "resource_sold",
		method: 'GET',
    })
}

// 上传人数
export const user_upload = (data) => {
    return axios({
        url: baseUrl + "user_upload",
		method: 'GET',
    })
}

//获取比例
export const requestoption = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "option?data=" + JSON.stringify(data)
	})
}
//申请发票
export const linvoice_add = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "linvoice_add?data=" + JSON.stringify(data)
	})
}
//申请发票列表
export const requestlinvoice_list = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "linvoice_list?data=" + JSON.stringify(data)
	})
}
//提现记录
export const requestWithdrawal_list = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "withdrawal_list?data=" + JSON.stringify(data)
	})
}
//提现记录
export const requestLinvoice_information = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "linvoice_information?data=" + JSON.stringify(data)
	})
}

//发票申请取消
export const requestLinvoice_modify = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "linvoice_modify?data=" + JSON.stringify(data)
	})
}

//提现申请取消
export const requestWithdrawal_modify = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "withdrawal_modify?data=" + JSON.stringify(data)
	})
}
//
export const log_goldcoin = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "log_goldcoin?data=" + JSON.stringify(data)
	})
}


//
export const account_project_add_list = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_project_add_list?data=" + JSON.stringify(data)
	})
}

//我的工程删除
export const account_project_delete = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_project_delete?data=" + JSON.stringify(data)
	})
}

//生成他人资源二维码
export const others_code_add = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "others_code_add?data=" + JSON.stringify(data)
	})
}


//他人二维码列表
export const requestothers_code_list = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "others_code_list?data=" + JSON.stringify(data)
	})
}



//删除他人二维码
export const others_code_delete = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "others_code_delete?data=" + JSON.stringify(data)
	})
}


//脚本预览
export const preview_script = (data) => {
	data.token = token()
	return axios({
		method: 'GET',
		url: baseUrl + "preview_script?data=" + JSON.stringify(data)
	})
}

//点赞
export const add_fabulous = (data) => {
	data.token = token()
	return axios({
		method: 'GET',
		url: baseUrl + "add_fabulous?data=" + JSON.stringify(data)
	})
}
//取消点赞
export const del_fabulous = (data) => {
	data.token = token()
	return axios({
		method: 'GET',
		url: baseUrl + "del_fabulous?data=" + JSON.stringify(data)
	})
}
//点赞
export const user_fabulous = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "user_fabulous?data=" + JSON.stringify(data)
	})
}
export const catalog_list = () => {
	return axios({
		method: 'GET',
		url: baseUrl + "nav_tree"
	})
}
export const resource_recommend = (data) => {
	return axios({
		method: 'GET',
		url: baseUrl + "resource_recommend?data=" + JSON.stringify(data)
	})
}
export const account_resource_bind = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_resource_bind?data=" + JSON.stringify(data)
	})
}
export const account_resource_public = (data) => {
	data.token = token()
	return axios({
		method: 'POST',
		url: baseUrl + "account_resource_public?data=" + JSON.stringify(data)
	})
}
// 首页列表
// export const resource_recommend = (data) => {
	// return axios({
	// 	method: 'GET',
	// 	url: baseUrl + "resource_recommend?data=" + JSON.stringify(data)
	// })
// }


// 脚本上传
export const requestjiaobenShowuploadfile= (info) => {
    console.log(info)
    console.log(JSON.stringify(info))
    return axios({
        method: 'POST',
        url:  "http://www.bimmodels.cn/platform/" + "show/resourceuploadfile",
		data:info
    })
}

export const index_config = () => {
	return axios({
		method: 'GET',
		url: baseUrl + "index_config"
	})
}